<div class="mibi-order-list">
    <h2 class="mibi-order-list__title">Ihre bisherigen Aufträge ans BfR</h2>
    <div class="mibi-order-list__content">
        <table
            mat-table
            [dataSource]="dataSource"
            matSort
            matSortActive="createdAt"
            matSortDirection="desc"
            class="mibi-order-list__table"
        >
            <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="mibi-order-list__col--created-at">Datum / Zeit</th>
                <td mat-cell *matCellDef="let row" class="mibi-order-list__col--created-at">{{ row.createdAt | date:'dd.MM.yyyy HH:mm' }}</td>
            </ng-container>

            <ng-container matColumnDef="fileName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Dateiname</th>
                <td mat-cell *matCellDef="let row" class="mibi-order-list__cell--wrap">{{ row.fileName }}</td>
            </ng-container>

            <ng-container matColumnDef="sampleIds">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Ihre Probenummer</th>
                <td mat-cell *matCellDef="let row" class="mibi-order-list__cell--wrap">{{ row.sampleIdsDisplay }}</td>
            </ng-container>

            <ng-container matColumnDef="sampleIdsAVV">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Probenummer nach AVV DatA</th>
                <td mat-cell *matCellDef="let row" class="mibi-order-list__cell--wrap">{{ row.sampleIdsAVVDisplay }}</td>
            </ng-container>

            <ng-container matColumnDef="pathogens">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Enthaltene Erreger</th>
                <td mat-cell *matCellDef="let row" class="mibi-order-list__cell--wrap">{{ row.pathogens }}</td>
            </ng-container>

            <ng-container matColumnDef="nrls">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Auftrag an</th>
                <td mat-cell *matCellDef="let row" class="mibi-order-list__cell--wrap">{{ row.nrls }}</td>
            </ng-container>

            <ng-container matColumnDef="sampleCount">
                <th mat-header-cell *matHeaderCellDef class="mibi-order-list__col--sample-count">Probenanzahl</th>
                <td mat-cell *matCellDef="let row" class="mibi-order-list__col--sample-count">{{ row.sampleCount }}</td>
            </ng-container>

            <ng-container matColumnDef="results">
                <th mat-header-cell *matHeaderCellDef class="mibi-order-list__col--narrow">BfR-Ergebnisse verfügbar</th>
                <td
                    mat-cell
                    *matCellDef="let row"
                    class="mibi-order-list__col--narrow"
                    [class.mibi-order-list__results--partial]="resultsCategory(row) === 'partial'"
                    [class.mibi-order-list__results--complete]="resultsCategory(row) === 'complete'"
                    [class.mibi-order-list__results--unseen]="resultsUnseen(row)"
                >{{ row.results }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="mibi-order-list__col--actions">Auftrag ansehen</th>
                <td mat-cell *matCellDef="let row" class="mibi-order-list__col--actions">
                    <button
                        mat-icon-button
                        type="button"
                        aria-label="Auftrag ansehen"
                        (click)="onOpenResults(row)"
                    >
                        <mat-icon>arrow_forward</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="filter-createdAt">
                <th mat-header-cell *matHeaderCellDef class="mibi-order-list__filter-cell">
                    <mibi-order-list-filter-input
                        [value]="activeFilter.columns.createdAt"
                        ariaLabel="Datum / Zeit filtern"
                        (valueChange)="onFilterChange('createdAt', $event)"
                    ></mibi-order-list-filter-input>
                </th>
            </ng-container>

            <ng-container matColumnDef="filter-fileName">
                <th mat-header-cell *matHeaderCellDef class="mibi-order-list__filter-cell">
                    <mibi-order-list-filter-input
                        [value]="activeFilter.columns.fileName"
                        ariaLabel="Dateiname filtern"
                        (valueChange)="onFilterChange('fileName', $event)"
                    ></mibi-order-list-filter-input>
                </th>
            </ng-container>

            <ng-container matColumnDef="filter-sampleIds">
                <th mat-header-cell *matHeaderCellDef class="mibi-order-list__filter-cell">
                    <mibi-order-list-filter-input
                        [value]="activeFilter.columns.sampleIds"
                        ariaLabel="Probenummer filtern"
                        (valueChange)="onFilterChange('sampleIds', $event)"
                    ></mibi-order-list-filter-input>
                </th>
            </ng-container>

            <ng-container matColumnDef="filter-sampleIdsAVV">
                <th mat-header-cell *matHeaderCellDef class="mibi-order-list__filter-cell">
                    <mibi-order-list-filter-input
                        [value]="activeFilter.columns.sampleIdsAVV"
                        ariaLabel="Probenummer nach AVV DatA filtern"
                        (valueChange)="onFilterChange('sampleIdsAVV', $event)"
                    ></mibi-order-list-filter-input>
                </th>
            </ng-container>

            <ng-container matColumnDef="filter-pathogens">
                <th mat-header-cell *matHeaderCellDef class="mibi-order-list__filter-cell">
                    <mibi-order-list-filter-input
                        [value]="activeFilter.columns.pathogens"
                        ariaLabel="Enthaltene Erreger filtern"
                        (valueChange)="onFilterChange('pathogens', $event)"
                    ></mibi-order-list-filter-input>
                </th>
            </ng-container>

            <ng-container matColumnDef="filter-nrls">
                <th mat-header-cell *matHeaderCellDef class="mibi-order-list__filter-cell">
                    <mibi-order-list-filter-input
                        [value]="activeFilter.columns.nrls"
                        ariaLabel="Auftrag an filtern"
                        (valueChange)="onFilterChange('nrls', $event)"
                    ></mibi-order-list-filter-input>
                </th>
            </ng-container>

            <ng-container matColumnDef="filter-sampleCount"><th mat-header-cell *matHeaderCellDef class="mibi-order-list__filter-cell"></th></ng-container>
            <ng-container matColumnDef="filter-results">
                <th mat-header-cell *matHeaderCellDef class="mibi-order-list__filter-cell">
                    <mibi-order-list-filter-select
                        [value]="activeFilter.results"
                        ariaLabel="BfR-Ergebnisse filtern"
                        (valueChange)="onResultsFilterChange($event)"
                    ></mibi-order-list-filter-select>
                </th>
            </ng-container>
            <ng-container matColumnDef="filter-actions"><th mat-header-cell *matHeaderCellDef class="mibi-order-list__filter-cell"></th></ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-header-row *matHeaderRowDef="[
                'filter-createdAt',
                'filter-fileName',
                'filter-sampleIds',
                'filter-sampleIdsAVV',
                'filter-pathogens',
                'filter-nrls',
                'filter-sampleCount',
                'filter-results',
                'filter-actions'
            ]; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="mibi-order-list__footer-row">
            <span class="mibi-order-list__footer">{{ rowCount }} Aufträge</span>
            <mat-paginator
                class="mibi-order-list__paginator"
                [pageSizeOptions]="[5, 10, 25, 50]"
                [pageSize]="10"
                showFirstLastButtons
            ></mat-paginator>
        </div>

        @if (showConsentHint) {
            <p class="mibi-order-list__empty-hint">
                Wenn Sie Ihre hochgeladenen Daten hier sehen und damit Zugang zu den
                BfR-Analyseergebnissen erhalten möchten, stimmen Sie bitte auf der
                <a [routerLink]="[userLinks.profile]">Profilseite</a> der Datenspeicherung zu.
            </p>
        } @else if (showNoOrdersHint) {
            <p class="mibi-order-list__empty-hint">
                Sie haben dem Speichern Ihrer Isolatdaten zugestimmt. Sobald Sie einen
                Untersuchungsauftrag ans BfR gesandt haben, wird er in dieser Tabelle
                aufgeführt. Das Speichern sowie E-Mail-Einstellungen können auf der
                <a [routerLink]="[userLinks.profile]">Profilseite</a> angepasst werden.
            </p>
        }
    </div>
</div>
